import { fetchWeatherStart, fetchWeatherSuccess, fetchWeatherFailure } from '../slices/weatherSlice';
import { fetchWeatherFromAPI } from '../weather/weatherService';

/**
 * Action Creator: fetchWeather
 * @description Fetches weather data for a given address and updates the Redux store.
 * @param {string} address - The location address to fetch weather for.
 * @returns {Function} A thunk function that handles the API call and dispatches actions.
 */
export const fetchWeather = (address) => async (dispatch) => {
  if (!address) {
    dispatch(fetchWeatherFailure('Address is required to fetch weather data'));
    return;
  }

  try {
    dispatch(fetchWeatherStart());
    const data = await fetchWeatherFromAPI(address);
    dispatch(fetchWeatherSuccess(data));
  } catch (error) {
    dispatch(fetchWeatherFailure(error.message));
  }
};
